"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var OvertimeTable = function OvertimeTable(props) {
  var data = props.data;
  var _useMemo = (0, _react.useMemo)(function () {
      return {
        total: data.rows.reduce(function (num, item) {
          return num + item.total;
        }, 0),
        hasCode: data.rows.some(function (item) {
          return item.code;
        })
      };
    }, [data]),
    total = _useMemo.total,
    hasCode = _useMemo.hasCode;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].tableWrapper
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: (0, _classnames["default"])('table table-condensed', _style["default"].table)
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, "\xA0"), data.columns.map(function (column) {
    return /*#__PURE__*/_react["default"].createElement("th", {
      key: column.code,
      className: "text-center"
    }, column.label);
  }), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-center"
  }, "TOTAL"))), /*#__PURE__*/_react["default"].createElement("tbody", null, data.rows.map(function (row) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: row.label
    }, /*#__PURE__*/_react["default"].createElement("td", {
      className: (0, _classnames["default"])(row.isOthers && _style["default"].others)
    }, /*#__PURE__*/_react["default"].createElement("b", null, row.label), hasCode && 'code' in row && " (".concat(row.code, ")")), data.columns.map(function (column, index) {
      return /*#__PURE__*/_react["default"].createElement("td", {
        key: column.code,
        className: "text-center"
      }, row.values[index]);
    }), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-center"
    }, /*#__PURE__*/_react["default"].createElement("b", null, row.total)));
  })), /*#__PURE__*/_react["default"].createElement("tfoot", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, "TOTAL"), data.columns.map(function (column, index) {
    return /*#__PURE__*/_react["default"].createElement("td", {
      key: column.code,
      className: "text-center"
    }, column.total);
  }), /*#__PURE__*/_react["default"].createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement("b", null, total))))));
};
OvertimeTable.propTypes = {
  data: _propTypes["default"].object
};
var _default = exports["default"] = OvertimeTable;